var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lamp-tip',{attrs:{"local-key":"mng.dataRule.list"}},[_c('div',{staticClass:"lamptip-desc"},[_c('p',[_vm._v(_vm._s(_vm.$t('通过设置共享规则，企业可为员工赋予额外数据权限，实现更加灵活的权限管理。')))]),_c('p',[_vm._v(_vm._s(_vm.$t('共享数据设置不影响员工已有权限角色中的设置。')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }